module.exports = __webpack_public_path__ + "static/media/programimg3.5e3fe245.png";